import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardLayoutComponent } from './modules/layout/container/dashboard-layout/dashboard-layout.component';
import { HomeLayoutComponent } from './modules/layout/container/home-layout/home-layout.component';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { ProgramCertificateComponent } from './modules/dashboard/container/program-certificate/program-certificate.component';
import { PartnerDashboardLayoutComponent } from './modules/layout/container/partner-dashboard-layout/partner-dashboard-layout.component';
import { AuthGuardAdminService } from './core/guards/auth-guard-admin.service';
import { CertificateShareComponent } from './modules/dashboard/container/certificate-share/certificate-share.component';

const routes: Routes = [
  {
    path: "auth/forgot-password",
    component: HomeLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('src/app/modules/auth/auth.module').then(m => m.AuthModule) }
    ]
  },
  {
    path: "dashboard",
    component: DashboardLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      // canActivate: [AuthGuard],
      { path: 'notes-bookmarks', loadChildren: () => import('src/app/modules/notes-bookmarks/notes-bookmarks.module').then(m => m.NotesBookmarksModule) },
      { path: 'habit-drills', loadChildren: () => import('src/app/modules/habit-drills/habit-drills.module').then(m => m.HabitDrillsModule) },
      // { path: 'test', loadChildren: () => import('src/app/modules/test/test.module').then(m => m.TestModule) },
      { path: 'leaderborad', loadChildren: () => import('src/app/modules/leaderboard/leaderboard.module').then(m => m.LeaderboardModule) },
      { path: 'ipj-bot', loadChildren: () => import('src/app/modules/ipj-bot/ipj-bot.module').then(m => m.IpjBotModule) },
      { path: 'reports', loadChildren: () => import('src/app/modules/reports/reports.module').then(m => m.ReportsModule) },
      { path: 'sessions', loadChildren: () => import('src/app/modules/sessions/sessions.module').then(m => m.SessionsModule) },
      { path: 'certificate/share-post', component: CertificateShareComponent },
      { path: '', loadChildren: () => import('src/app/modules/dashboard/dashboard.module').then(m => m.DashboardModule) },

    ]
  },
  {
    path: "learning-insights",
    component: PartnerDashboardLayoutComponent,
    canActivate: [AuthGuardAdminService],
    children: [

      { path: '', loadChildren: () => import('./modules/layout/container/partner-dashboard-layout/partner-layout.module').then(m => m.PartnerLayoutModule) }

    ]
  }, 
  { path: 'info-review', loadChildren: () => import('src/app/modules/info-review/info-review.module').then(m => m.InfoReviewModule), canActivate: [AuthGuardService] },
  {
    path: 'login',
    component: HomeLayoutComponent,
    children: [
      // { path: '', redirectTo: 'auth', pathMatch: 'full' },
      { path: '', loadChildren: () => import('src/app/modules/auth/auth.module').then(m => m.AuthModule) }
    ]
  },
  { path: 'player/:courseId', loadChildren: () => import('src/app/modules/player/player.module').then(m => m.PlayerModule), canActivate: [AuthGuardService] },
  {
    path: 'benchmarking',
    component: HomeLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: '', loadChildren: () => import('src/app/modules/test/test.module').then(m => m.TestModule) }
    ]
  },
  // { path: 'benchmarking', loadChildren: () => import('src/app/modules/test/test.module').then(m => m.TestModule),canActivate: [AuthGuardService] },

  { path: 'program-certificate/:id', component: ProgramCertificateComponent },
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' }
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }